import Button, { ButtonProps } from 'antd/lib/button';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RunwayUserAction } from '../../helpers/aclHelpers';
import { RootState } from '../../reducers/reducers';
import { selectAuthCredentials } from '../../selectors/selectors';
import { globalMessage } from '../../utils/globalMessage';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';
import * as API from '../../api';
import qs from 'query-string';

interface AuthedLinkButtonProps extends ButtonProps {
    linkUrl: string;
    onLinkAuthed: (authedLink: string) => void;
    actionType?: RunwayUserAction; // for a permissioned authed button
    releaseId?: string; // used for permissioned authed button
    bucketId?: string;
}

const AuthedUrlButton: React.FC<AuthedLinkButtonProps> = (props: AuthedLinkButtonProps) => {
    const { actionType, releaseId, bucketId, linkUrl, children, ...rest } = props;
    const [getTokenIsLoading, setGetTokenIsLoading] = React.useState(false);
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));

    const getShortLivedToken = React.useCallback(() => {
        setGetTokenIsLoading(true);

        API.getShortLivedToken(authCredentials!)
            .then((token) => {
                const params = {
                    t: token,
                };
                const authedUrl = qs.stringifyUrl({ url: linkUrl, query: params });

                props.onLinkAuthed(authedUrl);
            })
            .catch(() => {
                globalMessage.error('Failed to auth download link. Please try again.');
            })
            .finally(() => {
                setGetTokenIsLoading(false);
            });
    }, [authCredentials]);

    if (actionType) {
        return (
            <PermissionedActionButton
                actionType={actionType}
                releaseId={releaseId}
                bucketId={bucketId}
                onClick={getShortLivedToken}
                loading={getTokenIsLoading}
                {...rest}
            >
                {children}
            </PermissionedActionButton>
        );
    }

    return (
        <Button onClick={getShortLivedToken} loading={getTokenIsLoading} {...rest}>
            {children}
        </Button>
    );
};

export default AuthedUrlButton;
